import styled from 'styled-components';
import UiTabsItem from '../../ui/tabs/item/UiTabsItem';

export default styled(UiTabsItem)`
    justify-content: center;

    & .inbox-tab-label {
        display: flex;
        align-items: center;
        gap: var(--spacing-4);
    }
`;
